import { ExtraWorkOrderStatus } from '../models';

/**
 * 🎯 Configuración de estados para órdenes de trabajo extra
 * 
 * Define los estilos (colores de fondo y texto) para cada estado
 */
export const extraWorkOrderStatusConfig: Record<
  ExtraWorkOrderStatus,
  { label: string; bg: string; text: string }
> = {
  PENDING: {
    label: 'pendiente',
    bg: 'bg-card-border light:bg-badge-bg-status-1',
    text: 'text-badge-status-1',
  },
  IN_PROGRESS: {
    label: 'progreso',
    bg: 'bg-card-border light:bg-bg-warning',
    text: 'text-warning',
  },
  DONE: {
    label: 'completo',
    bg: 'bg-bg-success',
    text: 'text-success',
  },
};

/**
 * Obtener la configuración de un estado
 */
export const getExtraWorkOrderStatusConfig = (
  status: ExtraWorkOrderStatus
) => {
  return extraWorkOrderStatusConfig[status] || extraWorkOrderStatusConfig.PENDING;
};
